import { useSetAtom } from 'jotai';
import { useParams } from 'react-router-dom';
import {
  DEFAULT_PERIOD,
  DEFAULT_TRACK,
  DEFAULT_VERSION,
  selectedMetadataAtom,
} from '../atoms/selectedMetadata';
import {
  DEFAULT_TIMESTAMP_SELECTION_METHOD,
  INITIAL_VIDEO_SOURCE_VALUE,
  selectedTimestampSelectionMethodAtom,
  selectedVideoSourceAtom,
} from '../atoms/selectedVideoData';
import { FOOTBALL_IDENTIFIER, sanitiseSport } from '../components/Sport/Sport';
import { sanitiseTrack } from '../components/Track/Track';

export function useClearSelections() {
  const setSelectedMetadata = useSetAtom(selectedMetadataAtom);
  const setSelectedVideoSource = useSetAtom(selectedVideoSourceAtom);
  const setSelectedTimestampSelectionMethod = useSetAtom(
    selectedTimestampSelectionMethodAtom,
  );

  const {
    sport: providedSport,
    matchId: providedMatchId,
    period: providedPeriod,
    version: providedVersion,
    track: providedTrack,
  } = useParams();

  const resetSelections = (onAllValuesProvided, onMatchProvided) => {
    setSelectedVideoSource(INITIAL_VIDEO_SOURCE_VALUE);
    setSelectedTimestampSelectionMethod(DEFAULT_TIMESTAMP_SELECTION_METHOD);

    const sanitisedSport = sanitiseSport(providedSport);
    const sanitisedTrack = sanitiseTrack(providedTrack);

    setSelectedMetadata({
      matchId: providedMatchId || '',
      period: providedPeriod || DEFAULT_PERIOD,
      sport: sanitisedSport || FOOTBALL_IDENTIFIER,
      track: sanitisedTrack || DEFAULT_TRACK,
      version: providedVersion || DEFAULT_VERSION,
    });

    if (
      providedSport &&
      providedMatchId &&
      providedPeriod &&
      providedTrack &&
      providedVersion &&
      onAllValuesProvided
    ) {
      onAllValuesProvided(
        sanitisedSport,
        providedMatchId,
        providedPeriod,
        sanitisedTrack,
        providedVersion,
      );
    }

    if (providedSport && providedMatchId && onMatchProvided) {
      onMatchProvided(sanitisedSport, providedMatchId);
    }
  };

  return { resetSelections };
}

export default { useClearSelections };
